<template>
  <div class="prototype-page">
    <div class="app-shell">
      <header class="page-header">
        <div class="header-inner">
          <div class="logo">
            <div class="logo-badge">3P</div>
            <span class="site-title">3P影视</span>
          </div>
          <div class="domain-display">
            <div class="domain-slider">
              <span v-for="(domain, idx) in domains" :key="idx" class="domain-item">{{ domain }}</span>
            </div>
          </div>
          <router-link class="header-action" to="/">返回</router-link>
        </div>
        <!-- <div class="search-bar-container">
          <div class="search-bar">搜索视频 / 分类 / 主播</div>
        </div> -->
      </header>

      <section class="section">
        <div class="section-title">
          <h2>分类筛选</h2>
          <span>横向切换频道</span>
        </div>
        <div class="category-row" v-if="categories.length > 0">
        <div
          v-for="item in categories"
          :key="item.id"
          class="chip-cool"
          :class="{ active: item.id === activeCategory }"
          @click="handleCategoryChange(item)"
        >
          <span class="chip-text">{{ item.name }}</span>
        </div>
      </div>
      </section>
      
     

      <section class="section">
        <div class="section-title">
          <h2>视频列表</h2>
        </div>
        
        <van-list
          v-model="loading"
          :immediate-check="true"
          loading-text="加载中..."
          :finished="finished"
          finished-text="没有更多了"
          @load="doGetList"
          offset="300" direction="down"
          class="grid video-grid"
        >
          <router-link
            v-for="(video, index) in displayList"
            :key="`${video.id || video.vid || video.number || 'v'}-${index}`"
            class="video-card"
            :to="`/detail?id=${video.id || video.vid}`"
          >
            <div class="video-cover">
              
              
              <img :src="video.thumb_image || getCoverUrl(video)" :alt="video.title">
              <span class="video-duration">{{ video.times || video.duration || '00:00' }}</span>
            </div>
            <div class="video-body">
              <p class="video-title">{{ video.title }}</p>
              <div class="meta-row">
                <span>{{ video.day || video.updatetime || '刚刚' }}</span>
                <span>{{ video.rand ? `已有${video.rand}人看过` : `${video.looks || 0} 播放` }}</span>
              </div>
            </div>
          </router-link>
        </van-list>
      </section>

    </div>
  </div>
</template>

<script>
import { getBannerUrl, getCachedNavUrlList, getCoverUrl } from "@/prototype/render-helpers";
import { siteData } from "@/prototype/site-data";
import { nc6Api, vlv6Api } from "@/api/api";

export default {
  name: "ListPage",
  data() {
    return {
      domains: getCachedNavUrlList(),
      activeCategory: 0,
      activeSort: "hot",
      sortOptions: [
        { label: "最热", value: "hot" },
        { label: "最新", value: "new" },
        { label: "推荐", value: "recommend" }
      ],
      siteData,
      categories: [],
      dataList: [],
      loading: false,
      finished: false,
      params: {
        cate_id: 0,
        key: "",
        page: 1,
        limit: 10,
        ldk: window.localStorage.getItem("ldk") || "",
        payed: 0,
        templete_id: 1,
        uid: window.localStorage.getItem("visitorId") || "",
        webmanage: 0,
      },
    };
  },
  computed: {
    displayList() {
      const list = this.dataList.slice();
      if (this.activeSort === "new") {
        return list.sort((a, b) => {
          const aValue = a.day || a.create_time || a.id || a.vid || 0;
          const bValue = b.day || b.create_time || b.id || b.vid || 0;
          return String(bValue).localeCompare(String(aValue));
        });
      }
      if (this.activeSort === "recommend") {
        return list;
      }
      return list.sort((a, b) => Number(b.rand || b.looks || 0) - Number(a.rand || a.looks || 0));
    },
  },
  mounted() {
    this.fetchCategories();
  },
  watch: {
    "$route.query.cateId"() {
      this.syncCategoryFromRoute();
      this.fetchDataList(true);
    },
  },
  methods: {
    getBannerUrl,
    getCoverUrl,
    getRouteCateId() {
      const cateId = Number(this.$route.query.cateId || 0);
      return Number.isFinite(cateId) ? cateId : 0;
    },
    decryptPayload(payload) {
      try {
        const decryptedText = this.$decryptData(payload);
        return decryptedText ? JSON.parse(decryptedText) : null;
      } catch (error) {
        console.error("Failed to decrypt payload", error);
        return null;
      }
    },
    async fetchCategories() {
      try {
        const res = await nc6Api({ ldk: this.params.ldk });
        const list = this.decryptPayload(res);
        if (Array.isArray(list)) {
          this.categories = [{ id: 0, name: "全部" }, ...list];
        } else {
          this.categories = [{ id: 0, name: "全部" }];
        }
        this.syncCategoryFromRoute();
        this.fetchDataList(true);
      } catch (error) {
        console.error("Failed to fetch categories", error);
      }
    },
    syncCategoryFromRoute() {
      const cateId = this.getRouteCateId();
      if (!cateId) {
        this.activeCategory = 0;
        this.params.cate_id = 0;
        return;
      }
      const index = this.categories.findIndex((item) => item.id == cateId);
      this.activeCategory = index >= 0 ? this.categories[index].id : 0;
      this.params.cate_id = this.activeCategory;
    },
    handleCategoryChange(item) {
      this.activeCategory = item.id;
      this.params.cate_id = item.id || 0;
      this.fetchDataList(true); // 添加此行：点击分类时立刻刷新数据
      this.$router.replace({
        path: "/list",
        query: {
          ...this.$route.query,
          category: item.name || "",
          cateId: item.id || 0,
        },
      });
    },
    handleSortChange(item) {
      this.activeSort = item.value;
      this.fetchDataList(true);
    },
    async fetchDataList(isRefresh = true) {
      if (isRefresh) {
        this.params.page = 1;
        this.finished = false;
        this.dataList = [];
      }
      
      this.loading = true;

      try {
        const currentPage = this.params.page;
        this.params.sp = window.localStorage.getItem("sp") || "";
        this.params.ua = window.localStorage.getItem("parent") || "";
        this.params.cate_id = this.getRouteCateId() || this.activeCategory || 0;
        const res = await vlv6Api({
          ...this.params,
        });
        const temp = this.decryptPayload(res);
       
        
        if (!temp || !Array.isArray(temp.data)) {
          this.finished = true;
          this.loading = false;
          return;
        }

        const nextList = temp.data;
        this.dataList = isRefresh ? nextList : [...this.dataList, ...nextList];
        
        // 增加页码
        if (currentPage < Number(temp.last_page || 1) && nextList.length > 0) {
          this.params.page++;
        } else {
          this.finished = true;
        }
      } catch (error) {
        this.finished = true;
      } finally {
        this.loading = false;
      }
    },
    doGetList() {
      this.fetchDataList(false);
    },
  },
};
</script>
